import React from 'react';
import { IUserList } from './InvitePeople';
import Userprofile from '../Userprofile/Userprofile';

export interface IUsersList {
  userData: IUserList[];
  type: 'all' | 'fans' | 'friends';
  handleClickOnSelectUser: (item: IUserList) => void;
  selectedUsers: IUserList[];
  isUserListLoading: boolean;
}

const UsersList = React.forwardRef<HTMLDivElement | null, IUsersList>(
  (
    {
      userData,
      type,
      handleClickOnSelectUser,
      selectedUsers,
      isUserListLoading,
    },
    ref
  ) => {
    return (
      <div
        className={`overflow-auto mt-2 scroll-5 ${
          selectedUsers.length
            ? 'max-h-[calc(100dvh-300px)]'
            : 'max-h-[calc(100dvh-220px)]'
        }`}
      >
        {isUserListLoading && userData.length === 0 ? (
          <h4 className="text-center my-8 text-white">Loading...</h4>
        ) : userData.length ? (
          <>
            <div className="space-y-4 py-2">
              {userData.map((item) => {
                return (
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    key={item.id}
                    onClick={() => {
                      handleClickOnSelectUser(item);
                    }}
                  >
                    <div className="flex items-center gap-4 pl-2">
                      <Userprofile item={item} />
                      <div>
                        <h4 className="text-primary text-[18px] line-clamp-1 block">
                          {item.first_name} {item.last_name}
                        </h4>
                        <h4 className="text-[16px] text-[#AE8A27] line-clamp-1 block">
                          {item.country}
                        </h4>
                      </div>
                    </div>

                    <label
                      className="custom-container"
                      htmlFor={`invite-user-name-${item.id}`}
                    >
                      <input
                        type="checkbox"
                        tabIndex={1}
                        name={`invite-user-name-${item.id}`}
                        id={`invite-user-name-${item.id}`}
                        checked={
                          selectedUsers.find((i) => i.id === item.id)
                            ? true
                            : false
                        }
                      />
                      <span
                        className="checkmark"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleClickOnSelectUser(item);
                        }}
                      ></span>
                    </label>
                  </div>
                );
              })}
            </div>

            <div ref={ref}>
              {isUserListLoading && (
                <h5 className="text-white text-center py-2">Loading...</h5>
              )}
            </div>
          </>
        ) : (
          <h4 className="text-center my-8 text-white">
            No {type === 'all' ? 'users' : type} found
          </h4>
        )}
      </div>
    );
  }
);

export default UsersList;
